import Vue from 'vue';
import VueMeta from 'vue-meta'
import VueToast from 'vue-toast-notification';
import 'vue-toast-notification/dist/theme-sugar.css';
import * as jQuery from 'jquery'
import './jquery.extend'

Vue.use(VueMeta, {
    // optional pluginOptions
    refreshOnceOnNavigation: true
});

Vue.use(VueToast);

export default class  {
    static autoregisterComponents() {
        const files = require.context('../../views/partials', true, /\.vue$/i);
        window.allFiles = files;
        files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default));
    }

    static registerGlobalLibraries() {
        this.registerjQuery();
        this.registerBootstrap();
    }

    static registerBootstrap() {
        require('bootstrap');
    }

    static registerjQuery() {
        window.$ = window.jQuery = jQuery;
    }
}
